import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import HomePage          from './pages/HomePage';
import LoginPage         from './pages/LoginPage';
import RegisterPage      from './pages/RegisterPage';
import AdminPage         from './pages/AdminPage';
import DashboardPage     from './pages/DashboardPage';
import PerfilPage        from './pages/PerfilPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import AuxiliarPage     from './pages/AuxiliarPage';
import ResetPasswordPage  from './pages/ResetPasswordPage';

function PrivateRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="auth-container">
      <div className="loading-screen"><div className="spinner" /> Carregando...</div>
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/perfil" replace />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();

  // Redireciona usuário já logado para sua área
  const dashRedirect = user
    ? <Navigate to={user.role === 'ADMIN' ? '/admin' : user.role === 'COORDENADOR_GERAL' ? '/dashboard' : '/perfil'} replace />
    : null;

  return (
    <Routes>
      {/* Página inicial pública */}
      <Route path="/"      element={dashRedirect || <HomePage />} />

      {/* Login */}
      <Route path="/login" element={dashRedirect || <LoginPage />} />

      {/* Recuperação de senha — rotas públicas */}
      <Route path="/recuperar-senha"          element={<ForgotPasswordPage />} />
      <Route path="/redefinir-senha/:token"   element={<ResetPasswordPage />} />

      {/* Cadastro via convite */}
      <Route path="/cadastro/:token" element={<RegisterPage />} />

      {/* Áreas protegidas */}
      <Route path="/admin"     element={<PrivateRoute roles={['ADMIN']}><AdminPage /></PrivateRoute>} />
      <Route path="/auxiliar"  element={<PrivateRoute roles={['AUXILIAR_ADM']}><AuxiliarPage /></PrivateRoute>} />
      <Route path="/dashboard" element={<PrivateRoute roles={['COORDENADOR_GERAL','ADMIN']}><DashboardPage /></PrivateRoute>} />
      <Route path="/perfil"    element={<PrivateRoute><PerfilPage /></PrivateRoute>} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
